import { useQuery } from '@tanstack/react-query'
import { useToast } from '@machobear/design-system'
import { getStandaloneTrustScoreList } from '@/models/standalone-trust-score/apis'

export const getTrustScoreList = async ({
  currentTab,
  searchString,
  page,
  limit,
  sortBy,
  sortOrder
}: {
  currentTab: string
  searchString: string
  page: number
  limit: number
  sortBy: string
  sortOrder: string
}) => {
  try {
    const response = await getStandaloneTrustScoreList({
      body: {
        criteria: {
          tab: currentTab,
          search: searchString,
          sortBy: sortBy,
          sortOrder: sortOrder
        },
        page: page,
        limit: limit
      }
    })
    return response
  } catch (error) {
    console.error(error)
  }
}

const useGetTrustScoreList = ({
  currentTab,
  searchString,
  page,
  limit,
  sortBy,
  sortOrder
}: {
  currentTab: string
  searchString: string
  page: number
  limit: number
  sortBy: string
  sortOrder: string
}) => {
  const showToast = useToast()

  const response = useQuery({
    queryKey: ['trustScoreList', currentTab, searchString, page, limit, sortBy, sortOrder],
    queryFn: async () => {
      const response = await getTrustScoreList({
        currentTab,
        searchString,
        page,
        limit,
        sortBy,
        sortOrder
      })
      if (!response?.response?.ok) {
        showToast({
          message: response?.body?.message,
          tone: 'critical'
        })
        throw new Error(response?.body)
      }

      return response?.body
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 5 * 60000
  })

  return response
}
export default useGetTrustScoreList
